
import React from 'react';
export const RenderNodeContext = React.createContext<HTMLElement>(document.body);
